import React, { useEffect, useReducer, useState } from "react";

import moment from "moment";
import { useTranslation } from "react-i18next";

import { useNotification } from "@hooks/useNotification";

import ModalIndex from "@Modals/layout/index";
import DateRangePickerDropdown from "@components/dateRange/DropdownDateRange";
import FormTextarea from "@components/formGroup/formTextarea";
import InputWithAddOptions from "@components/input/InputWithAddOptions";

import { checkEnterpriseId } from "@helpers/_functions";
import { UnavailabilityService } from "@services/all.services";

import useUnavalaibility from "./helpers/_functions";
import { ListboxSimple, Switch } from "@components/tailwindComponents";
import DefaultDatePicker from "@components/arhDatePicker/DefaultDatePicker";
import ArhTimePicker from "@components/arhDatePicker/arhTimePicker";
import { ClockBlack } from "@routes/IconeSvg"

const defaultReducer = (prevState, updatedProperty) => ({
  ...prevState,
  ...updatedProperty
});

const initialFieldStates = {
  /** @type {string=} */
  beginningOfPeriod: "",
  /** @type {string=} */
  endOfPeriod: "",
  /** @type {string=} */
  type: "",
  /** @type {string=} */
  notes: "",
  /** @type {object=} */
  periodSelected: null,
  /** @type {Date=} */
  initialEventDate: null,
  /** @type {Date=} */
  initialEventHour: null,
  /** @type {string=} */
  workStop: null,
  /** @type {string=} */
  wastedTime: null

};

const initialFieldErrors = {
  /** @type {boolean=} */
  periodSelected: false,
  /** @type {boolean=} */
  type: false,
  /** @type {boolean=} */
  initialEventDate: false
};

const ModalUpsertUnavailability = (props) => {
  const { employeeId } = props;
  const { t: translator } = useTranslation("pages.employés.emploi&Salary");
  const { showError, showSuccess } = useNotification();
  const [isLoading, setIsLoading] = useState(false);
  const {
    typeUnavailabilityList,
    unavailabilityPlaceList,
    unavailabilityMainCauseList,
    unavailabilityGravityList,
    unavailabilityInjuryNatureList,
    unavailabilityBodyLocationList,
    addTypeUnavailability,
    addUnavailabilityPlace,
    addUnavailabilityMainCause,
    addUnavailabilityGravity,
    addUnavailabilityInjuryNature,
    addUnavailabilityBodyLocation,
    deleteTypeUnavailability,
    deleteUnavailabilityPlace,
    deleteUnavailabilityMainCause,
    deleteUnavailabilityGravity,
    deleteUnavailabilityInjuryNature,
    deleteUnavailabilityBodyLocation
  } = useUnavalaibility();

  const arretTravailOptions = [
    { _id: "Oui", name: translator("Oui") },
    { _id: "Non", name: translator("Non") }
  ];
  const pertedeTempsOptions = [
    { _id: "Oui", name: translator("Oui") },
    { _id: "Non", name: translator("Non") }
  ];

  /** @type {[typeof initialFieldStates, Function]} */
  const [fieldStates, setFieldStates] = useReducer(
    defaultReducer,
    initialFieldStates
  );

  /** @type {[typeof initialFieldErrors, Function]} */
  const [fieldErrors, setFieldErrors] = useReducer(
    defaultReducer,
    initialFieldErrors
  );

  // reset fields from redux 
  useEffect(() => {
    if (!props.unavailabilitySelected) {
      setFieldStates(initialFieldStates);
    } else {
      const {
        beginningOfPeriod,
        endOfPeriod,
        initialEventDate: eventDate,
        workStop,
        wastedTime
      } = props.unavailabilitySelected;
      const initialEventDate = eventDate ? moment(eventDate, "YYYY-MM-DD HH:mm").toDate() : null
      const updatedInitialValue = {
        ...props.unavailabilitySelected,
        periodSelected: {
          startDate: moment(beginningOfPeriod, "YYYY-MM-DD").toDate(),
          endDate: moment(endOfPeriod, "YYYY-MM-DD").toDate()
        },
        initialEventDate,
        initialEventHour: initialEventDate,
        workStop: typeof workStop === 'boolean' ? (workStop ? arretTravailOptions[0] : arretTravailOptions[1]) : null,
        wastedTime: typeof wastedTime === 'boolean' ? (wastedTime ? pertedeTempsOptions[0] : pertedeTempsOptions[1]) : null
      }
      setFieldStates(updatedInitialValue);
    }

    setFieldErrors(initialFieldErrors);
  }, [props.isOpen]);

  function handleChangedate(date) {
    if (!date?.length) {
      return;
    }

    // let periodSelected;
    // if (fieldStates.periodSelected) {
    //   const { startDate, endDate } = fieldStates.periodSelected;
    //   periodSelected = {
    //     oldStart: startDate,
    //     oldEnd: endDate
    //   };
    // } else {
    //   periodSelected = {
    //     oldStart: date?.[0]?.startDate,
    //     oldEnd: date?.[0]?.endDate
    //   };
    // }

    // const oldStart = moment(periodSelected.oldStart);
    // const oldEnd = moment(periodSelected.oldEnd);

    let { startDate, endDate } = date?.[0];

    if (!moment(startDate).isBefore(endDate)) {
      showError("verification_two_object", {
        object1: "endDate",
        operator: "superiour",
        object2: "startDate"
      });
      return;
    }

    setFieldStates({
      periodSelected: {
        key: "selection",
        startDate,
        endDate,
        color: "#FCB698"
      }
    });
    setFieldErrors({ periodSelected: false });
    if (fieldStates.initialEventDate
      && (moment(startDate).isAfter(fieldStates.initialEventDate) || moment(endDate).isBefore(fieldStates.initialEventDate))) {
      setFieldErrors({ initialEventDate: true });
    } else {
      setFieldErrors({ initialEventDate: false });
    }
  }

  function handleChangeInitialEventDate(date) {
    if (!date) {
      setFieldStates({ initialEventDate: "" });
    } else {
      const initialEventDate = moment(date);
      setFieldStates({ initialEventDate: initialEventDate.format() });
    }
    setFieldErrors({ initialEventDate: false });
  }

  function resetDateFilter() {
    setFieldStates({ periodSelected: null });
  }

  function handleChangeTypeUnavailability(ev) {
    const unavailabilityType = ev.target.getAttribute("data-value"); //data-id

    setFieldStates({ type: unavailabilityType });
    setFieldErrors({ type: false });
  }

  function handleChangeUnavailabilityPlace(ev) {
    const unavailabilityPlace = ev.target.getAttribute("data-value");

    setFieldStates({ place: unavailabilityPlace });
  }

  function handleChangeUnavailabilityMainCause(ev) {
    const unavailabilityMainCause = ev.target.getAttribute("data-value");

    setFieldStates({ mainCause: unavailabilityMainCause });
  }

  function handleChangeUnavailabilityGravity(ev) {
    const unavailabilityGravity = ev.target.getAttribute("data-value");

    setFieldStates({ gravity: unavailabilityGravity });
  }

  function handleChangeUnavailabilityInjuryNature(ev) {
    const unavailabilityInjuryNature = ev.target.getAttribute("data-value");

    setFieldStates({ injuryNature: unavailabilityInjuryNature });
  }

  function handleChangeBodyLocationUnavailability(ev) {
    const unavailabilityBodyLocation = ev.target.getAttribute("data-value");

    setFieldStates({ bodyLocation: unavailabilityBodyLocation });
  }

  function handleChangeWorkStop(selectedValue) {
    setFieldStates({ workStop: selectedValue });
  }

  function handleChangeWastedTime(selectedValue) {
    setFieldStates({ wastedTime: selectedValue })
  }

  function handleChangeAccess(value) {
    setFieldStates({ accessDisabled: value });
  }

  function handleChangeInitialEventHour(hour) {
    setFieldStates({ initialEventHour: hour })
  }

  async function onSaveClicked() {
    setIsLoading(true);
    let errors = {};
    if (!fieldStates.periodSelected) {
      errors.periodSelected = true;
    }
    if (!fieldStates.type) {
      errors.type = true;
    }

    const formInvalid = Object.keys(errors).length !== 0;
    if (formInvalid) {
      setFieldErrors(errors);
      showError("field_obligatory");
      setIsLoading(false);
      return;
    }
    if (!fieldStates.initialEventDate && Boolean(fieldStates.initialEventHour)) {
      setFieldErrors({ initialEventDate: true });
      showError("please_enter_object_valid", { object: "aDate" });
      setIsLoading(false);
      return;
    }
    const {
      type,
      place,
      mainCause,
      gravity,
      injuryNature,
      bodyLocation,
      workStop,
      wastedTime,
      accessDisabled,
      notes,
      initialEventDate: initial,
      initialEventHour
    } = fieldStates;
    let initialEventDate = "";
    if (initial) {
      const initialHour = initialEventHour && moment(initialEventHour).isValid() ? moment(initialEventHour) : moment(
        "09:00",
        "HH:mm");
      initialEventDate = moment(initial).hour(initialHour.hour()).minute(initialHour.minute()).format("YYYY-MM-DD HH:mm");
    }
    try {
      const unavailability = {
        employer: employeeId,
        beginningOfPeriod: moment(fieldStates.periodSelected.startDate).format("YYYY-MM-DD"),
        endOfPeriod: moment(fieldStates.periodSelected.endDate).format("YYYY-MM-DD"),
        initialEventDate,
        isDemission: false,
        type,
        place,
        mainCause,
        gravity,
        injuryNature,
        bodyLocation,
        workStop: workStop?._id ? workStop?._id === "Oui" : undefined,
        wastedTime: wastedTime?._id ? wastedTime?._id === "Oui" : undefined,
        accessDisabled,
        notes,
        entreprise: localStorage.getItem("enterpriseId")
      };
      const response = props.unavailabilitySelected?._id ?
        await UnavailabilityService.updateById({ _id: props.unavailabilitySelected?._id, ...unavailability }) :
        await UnavailabilityService.insert(unavailability);

      if (response.msg === "superposition" || response.data?.msg === "superposition") {
        showError("superposition_unav_date");
        setFieldErrors({ periodSelected: true });
        setIsLoading(false);
        return;
      }

      setFieldStates(initialFieldStates);
      if (props.unavailabilitySelected?._id) {
        showSuccess("update_action_success", { object: "period_unav" });
      } else {
        showSuccess("creation_action_success", { object: "period_unav" });
      }
      props.refreshUnavailabilityList();
      setIsLoading(false);
      props.closeModal();
    } catch (err) {
      showError("error", err);
      setIsLoading(false);
    }
  }

  return (
    <ModalIndex
      isOpen={props.isOpen}
      title={props.unavailabilitySelected ? translator("Modifier une période indisponibilité") : translator(
        "Ajouter une période d'indisponibilité")}
      onClickClose={props.closeModal}
      isLoading={isLoading}
      widthType="large"
      buttonOptions={{
        click: onSaveClicked,
        color: "green",
        title: translator("Enregistrer")
      }}
      buttonCancelOptions={{
        click: props.closeModal,
        color: "outlined",
        title: translator("Annuler")
      }}
    >
      <div className="arh-w-full arh-flex arh-flex-col arh-px-8 arh-mt-8">
        <div className="arh-flex arh-flex-row arh-justify-between arh-gap-6">
          <div className="arh-flex arh-flex-col arh-w-1/2">

            <div className="arh-w-full arh-mb-2">
              <label
                className={`arh-mb-1 arh-flex arh-w-full arh-font-poppins arh-text-xs arh-font-medium ${fieldErrors.periodSelected
                  ? "arh-text-invalidColorTextInput"
                  : "arh-text-darkColor"
                  }  `}
              >
                {translator("Période d'indisponibilité") + " *"}
              </label>
              <div className="dropdown_content_hour items_filter datepicker_modals_parcours datePicker_posteAvailable  blackSvgColor">
                <div className=" dateRange_green position_relative DateRangePicker_customisation DateRangePicker_customisation--green">
                  <DateRangePickerDropdown
                    key="date_range_periode"
                    classParent="arhDatePicker"
                    idInput="daterange"
                    className={`input_simple ${fieldErrors.periodSelected ? "field_invalid" : ""
                      }`}
                    dateSelected={fieldStates.periodSelected}
                    textInput={translator("Période d'indisponibilité")}
                    SaveCloseRange={handleChangedate}
                    showResetFilter={true}
                    onResetFilter={resetDateFilter}
                    classSwitch="c-switch-pill-checked--green--color--to--left"
                    classBackground="green"
                    isInForeground={true}
                    marginTop={-10}
                    customClass="arh-bottom-[3.125rem] !arh-top-auto"
                  // setSuperZIndex={props.setSuperZIndex}
                  />
                </div>
              </div>
            </div>

            <div className="arh-flex arh-flex-row arh-justify-between arh-gap-2 arh-mb-2">
              <div className="arh-w-full calendar_with_btn employerThemeDatePicker wadeDatePicker">
                <label
                  className={`arh-mb-1 arh-flex arh-w-full arh-font-poppins arh-text-xs arh-font-medium 
                    ${fieldErrors.initialEventDate ? "arh-text-invalidColorTextInput placeholder:arh-text-invalidColorTextInput" : "arh-text-darkColor"}`}
                >
                  {translator("Date de l'événement initial")}
                </label>
                <DefaultDatePicker
                  className="focus_green employe_depuis GreenThemeSelect arh-font-normal"
                  dateValue={fieldStates.initialEventDate}
                  placeholder={translator("Date")}
                  setDateValue={handleChangeInitialEventDate}
                  isInForeground={true}
                  marginTop={0}
                  customClass="arh-bottom-12"
                  inputDatePicker="!arh-p-[1.43rem] !arh-h-0 "
                  showReset={true}
                  invalid={fieldErrors.initialEventDate}
                />
              </div>

              <div className="!arh-mb-0 arh-w-full enregistrement_content">
                <ArhTimePicker
                  label={translator("Heure")}
                  selectedTime={fieldStates.initialEventHour}
                  svgIcones={ClockBlack}
                  timeIntervals={15}
                  handleTimeChange={handleChangeInitialEventHour}
                  allowEmptyValue={true}
                />
              </div>

            </div>

            <div className="arh-w-full arh-mb-2">
              <label
                className="arh-mb-1 arh-flex arh-w-full arh-font-poppins arh-text-xs arh-font-medium arh-text-darkColor"
              >
                {translator("Cause principale")}
              </label>
              <InputWithAddOptions
                defaultText={translator("Cause principale")}
                optionsList={unavailabilityMainCauseList || []}
                secondDefaultText={translator("Ajouter")}
                name="name"
                optionListLabel="name"
                onChange={handleChangeUnavailabilityMainCause}
                addItem={(data) =>
                  addUnavailabilityMainCause({
                    ...data,
                    entreprise: checkEnterpriseId()
                  })
                }
                deleteItem={deleteUnavailabilityMainCause}
                showAction={true}
                hideEdit={true}
                // setSuperZIndex={props.setSuperZIndex}
                disableInputChange={true}
                defaultTextValue={props.unavailabilitySelected?.mainCause}
              />
            </div>

            <div className="arh-w-full arh-mb-2">
              <label
                className="arh-mb-1 arh-flex arh-w-full arh-font-poppins arh-text-xs arh-font-medium arh-text-darkColor"
              >
                {translator("Nature de la blessure/Maladie")}
              </label>
              <InputWithAddOptions
                defaultText={translator("Nature de la blessure/Maladie")}
                optionsList={unavailabilityInjuryNatureList || []}
                secondDefaultText={translator("Ajouter")}
                name="name"
                optionListLabel="name"
                onChange={handleChangeUnavailabilityInjuryNature}
                addItem={(data) =>
                  addUnavailabilityInjuryNature({
                    ...data,
                    entreprise: checkEnterpriseId()
                  })
                }
                deleteItem={deleteUnavailabilityInjuryNature}
                showAction={true}
                hideEdit={true}
                // setSuperZIndex={props.setSuperZIndex}
                disableInputChange={true}
                defaultTextValue={props.unavailabilitySelected?.injuryNature}
              />
            </div>

            <div className="arh-flex arh-items-center arh-justify-between arh-mb-2">
              <ListboxSimple
                placeholder={translator("Arrêt de travail")}
                name="workStop "
                label={translator("Arrêt de travail")}
                optionList={arretTravailOptions}
                selectedValue={fieldStates.workStop}
                setSelectedValue={handleChangeWorkStop}
                noRadio={true}
              />
            </div>
          </div>

          <div className="arh-flex arh-flex-col arh-w-1/2">
            <div className="arh-w-full arh-mb-2">
              <label
                className={`arh-mb-1 arh-flex arh-w-full arh-font-poppins arh-text-xs arh-font-medium ${fieldErrors.type
                  ? "arh-text-invalidColorTextInput"
                  : "arh-text-darkColor"
                  }  `}
              >
                {translator("Type d'indisponibilité *")}
              </label>
              <InputWithAddOptions
                defaultText={translator("Indisponibilité")}
                optionsList={typeUnavailabilityList || []}
                secondDefaultText={translator("Ajouter")}
                name="name"
                optionListLabel="name"
                onChange={handleChangeTypeUnavailability}
                addItem={(data) =>
                  addTypeUnavailability({
                    ...data,
                    entreprise: checkEnterpriseId()
                  })
                }
                deleteItem={deleteTypeUnavailability}
                showAction={true}
                hideEdit={true}
                validateDropdown={fieldErrors.type}
                // setSuperZIndex={props.setSuperZIndex}
                disableInputChange={true}
                defaultTextValue={props.unavailabilitySelected?.type}
              />
            </div>

            <div className="arh-w-full arh-mb-2">
              <label
                className="arh-mb-1 arh-flex arh-w-full arh-font-poppins arh-text-xs arh-font-medium arh-text-darkColor"
              >
                {translator("Lieu")}
              </label>
              <InputWithAddOptions
                defaultText={translator("Lieu")}
                optionsList={unavailabilityPlaceList || []}
                secondDefaultText={translator("Ajouter")}
                name="name"
                optionListLabel="name"
                onChange={handleChangeUnavailabilityPlace}
                addItem={(data) =>
                  addUnavailabilityPlace({
                    ...data,
                    entreprise: checkEnterpriseId()
                  })
                }
                deleteItem={deleteUnavailabilityPlace}
                showAction={true}
                hideEdit={true}
                // setSuperZIndex={props.setSuperZIndex}
                disableInputChange={true}
                defaultSelected={fieldStates.place}
                defaultTextValue={props.unavailabilitySelected?.place}
              />
            </div>

            <div className="arh-w-full arh-mb-2">
              <label
                className="arh-mb-1 arh-flex arh-w-full arh-font-poppins arh-text-xs arh-font-medium arh-text-darkColor"
              >
                {translator("Gravité")}
              </label>
              <InputWithAddOptions
                defaultText={translator("Gravité")}
                optionsList={unavailabilityGravityList || []}
                secondDefaultText={translator("Ajouter")}
                name="name"
                optionListLabel="name"
                onChange={handleChangeUnavailabilityGravity}
                addItem={(data) =>
                  addUnavailabilityGravity({
                    ...data,
                    entreprise: checkEnterpriseId()
                  })
                }
                deleteItem={deleteUnavailabilityGravity}
                showAction={true}
                hideEdit={true}
                // setSuperZIndex={props.setSuperZIndex}
                disableInputChange={true}
                defaultTextValue={props.unavailabilitySelected?.gravity}
              />
            </div>

            <div className="arh-w-full arh-mb-2">
              <label
                className="arh-mb-1 arh-flex arh-w-full arh-font-poppins arh-text-xs arh-font-medium arh-text-darkColor"
              >
                {translator("Emplacement sur le corps")}
              </label>
              <InputWithAddOptions
                defaultText={translator("Emplacement sur le corps")}
                optionsList={unavailabilityBodyLocationList || []}
                secondDefaultText={translator("Ajouter")}
                name="name"
                optionListLabel="name"
                onChange={handleChangeBodyLocationUnavailability}
                addItem={(data) =>
                  addUnavailabilityBodyLocation({
                    ...data,
                    entreprise: checkEnterpriseId()
                  })
                }
                deleteItem={deleteUnavailabilityBodyLocation}
                showAction={true}
                hideEdit={true}
                // setSuperZIndex={props.setSuperZIndex}
                disableInputChange={true}
                defaultTextValue={props.unavailabilitySelected?.bodyLocation}
              />
            </div>

            <div className="arh-flex arh-items-center arh-justify-between arh-mb-2">
              <ListboxSimple
                placeholder={translator("Perte de temps")}
                name="wastedTime"
                label={translator("Perte de temps")}
                optionList={pertedeTempsOptions}
                selectedValue={fieldStates.wastedTime}
                setSelectedValue={handleChangeWastedTime}
                noRadio={true}
              />
            </div>
          </div>
        </div>

        <div className="arh-w-full">
          <FormTextarea
            label="Notes"
            placeholder="Notes"
            name="notes"
            value={fieldStates.notes}
            onChange={(e) => {
              setFieldStates({ notes: e.target.value });
            }}
          />
        </div>
        <div className="arh-flex arh-items-center arh-mt-4">
          <span className="arh-mr-4 arh-font-poppins arh-text-xs arh-font-normal arh-text-black">
            {translator("Désactiver l'accès de l'employé pendant la période d'indisponibilité")}
          </span>
          <Switch
            color="arh-bg-greenColor"
            handleChange={handleChangeAccess}
            checked={fieldStates.accessDisabled}
          />
        </div>
      </div>
    </ModalIndex>
  );
}

export default ModalUpsertUnavailability;